import { Navigate, useParams } from 'react-router-dom';

import { PATHS } from '@/shared/constants/app/routes.constant.ts';

import { useDocsTree } from '../api/use-docs.query';
import {
  SECTION_INDEX_SLUG,
  findSection,
  firstDocOf,
  indexDocOf,
} from '../lib/docsNavigation';
import { DocsArticleView } from './DocsArticleView';

/**
 * `/docs/<section>` 진입.
 *
 * 섹션에 **대표 문서**(slug `index`)가 있으면 그 문서를 여기서 그대로 그린다 —
 * FAQ 처럼 섹션과 문서가 사실상 같은 경우를 위한 것이고, 이 주소가 그 문서의
 * 유일한 정식 주소다.
 *
 * 대표 문서가 없으면 예전처럼 첫 문서로 보낸다. 섹션 랜딩을 따로 만들면 인덱스
 * 카드와 내용이 겹치면서 두 화면이 조용히 갈라진다.
 */
export function DocsSectionEntryView() {
  const { section } = useParams();
  const { data: tree, isPending } = useDocsTree();

  // 트리가 오기 전에 리다이렉트하면 항상 인덱스로 튕긴다.
  if (isPending) return null;

  const found = findSection(tree, section);
  if (!found) return <Navigate to={PATHS.DOCS} replace />;

  const landing = indexDocOf(found);
  if (landing) {
    return <DocsArticleView sectionSlug={found.slug} docSlug={SECTION_INDEX_SLUG} />;
  }

  const first = firstDocOf(found);
  if (!first) return <Navigate to={PATHS.DOCS} replace />;
  return <Navigate to={first.path} replace />;
}
